var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickStartNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109.2 85.8",
    style: {
      enableBackground: "new 0 0 109.2 85.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E0F6FF;}\n\t.st1{fill:#1B3175;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E2E2E2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17444",
    transform: "translate(-89 -622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17443",
    transform: "translate(89 622)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_17443-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18007",
    className: "st0",
    d: "M58.2,29.6c-3.8-2.2-8.3-2.8-12.5-1.5c-6,1.8-10.7,5.8-14.6,10.2c-0.4,0.4-0.3,1,0.1,1.4 c0.3,0.2,0.7,0.3,1,0.2c2.3-1.1,4.8-1.4,7.3-1c4.8,0.9,6.1,3.5,6.1,3.5L58.2,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18008",
    className: "st1",
    d: "M45.6,42.8L45.6,42.8c-0.2,0-0.4-0.1-0.5-0.3c0,0-1.3-2.3-5.7-3.2c-2.4-0.4-4.8,0-6.9,1 c-0.8,0.3-1.6,0-2-0.8c-0.2-0.5-0.1-1.2,0.3-1.6c3.1-3.5,8.1-8.4,14.9-10.4c4.3-1.4,9-0.8,12.9,1.6c0.2,0.2,0.3,0.5,0.1,0.7 c0,0,0,0-0.1,0.1L45.9,42.7C45.8,42.8,45.7,42.9,45.6,42.8 M37.5,38.1c0.7,0,1.4,0.1,2,0.2c3.6,0.7,5.4,2.3,6.1,3.2l11.7-11.8 c-3.5-1.8-7.7-2.2-11.5-1.1c-6.5,1.9-11.3,6.7-14.4,10.1c-0.2,0.2-0.2,0.4,0,0.6c0.1,0.2,0.3,0.2,0.5,0.1 C33.8,38.6,35.6,38.2,37.5,38.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18009",
    className: "st0",
    d: "M71.1,47.4c1,4.3,0.1,8.8-2.4,12.3c-3.6,5.2-8.8,8.4-14.2,10.8c-0.5,0.2-1.1,0-1.3-0.5 c-0.2-0.3-0.1-0.7,0.2-1c1.7-1.8,2.9-4.1,3.2-6.6c0.6-4.8-1.4-6.9-1.4-6.9L71.1,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18010",
    className: "st1",
    d: "M54.1,71.1c-0.5,0-0.9-0.2-1.2-0.6c-0.4-0.6-0.4-1.3,0.1-1.9c1.7-1.7,2.7-3.9,3.1-6.3 c0.6-4.5-1.3-6.4-1.3-6.4c-0.2-0.2-0.2-0.5,0-0.7l0.1-0.1l16-8.1c0.3-0.1,0.6,0,0.7,0.3c0,0,0,0,0,0.1c1,4.4,0.1,9.1-2.5,12.8 c-4,5.9-10.2,9.1-14.4,11C54.5,71,54.3,71.1,54.1,71.1 M55.9,55.7c0.6,0.9,1.6,3.1,1.2,6.8c-0.4,2.6-1.5,5-3.3,6.9 c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.2,0.5,0.2c4.2-1.8,10.1-5,14-10.6c2.3-3.3,3.2-7.3,2.5-11.2L55.9,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18011",
    className: "st2",
    d: "M79.9,43.4C70,50.6,61.5,54.3,54.1,55.9l-9.3-12.7c3.8-6.6,10-13.6,19.8-20.7 c3.6-2.6,7.5-4.7,11.6-6.2c12-4.3,21.5-1.8,21.5-1.8s-0.6,9.8-8.4,19.9C86.7,37.8,83.5,40.9,79.9,43.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18012",
    className: "st1",
    d: "M54.1,56.4c-0.2,0-0.3-0.1-0.4-0.2l-9.3-12.8c-0.1-0.2-0.1-0.4,0-0.6 c4.3-7.4,10.8-14.2,20-20.9c3.6-2.6,7.6-4.7,11.8-6.3c12-4.3,21.4-2,21.8-1.9c0.2,0.1,0.4,0.3,0.4,0.5c0,0.4-0.7,10.1-8.5,20.2 c-2.7,3.5-6,6.6-9.6,9.3c-9.2,6.7-17.7,10.8-26,12.6C54.2,56.4,54.2,56.4,54.1,56.4 M45.5,43.1l8.9,12.2 c8.1-1.8,16.4-5.8,25.3-12.3c3.5-2.6,6.7-5.6,9.3-9.1c4.4-5.6,7.2-12.2,8.2-19.1c-7-1.2-14.1-0.5-20.7,1.9 c-4.1,1.5-8,3.6-11.5,6.1C56,29.4,49.6,36,45.5,43.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18013",
    className: "st1",
    d: "M49.9,60.8l-11-15.1l5.9-2.5l9.3,12.7L49.9,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18014",
    className: "st1",
    d: "M49.9,61.3L49.9,61.3c-0.2,0-0.3-0.1-0.4-0.2L38.5,46c-0.2-0.2-0.1-0.6,0.1-0.7l0,0 c0,0,0.1,0,0.1-0.1l5.9-2.5c0.2-0.1,0.5,0,0.6,0.2l9.2,12.7c0.2,0.2,0.2,0.5,0,0.6l-4.2,4.9C50.2,61.2,50.1,61.3,49.9,61.3  M39.7,45.9l10.2,14l3.5-4l-8.8-12.1L39.7,45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18015",
    className: "st0",
    d: "M73.2,25.5c3.7,0,6.7,3,6.7,6.7s-3,6.7-6.7,6.7s-6.7-3-6.7-6.7 C66.5,28.6,69.5,25.5,73.2,25.5L73.2,25.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18016",
    className: "st1",
    d: "M73.2,39.6c-4,0-7.3-3.2-7.3-7.3c0-4,3.2-7.3,7.3-7.3s7.3,3.2,7.3,7.3 c0,2.3-1.1,4.5-3,5.9C76.2,39.1,74.7,39.6,73.2,39.6 M73.2,26.1c3.5,0,6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3 C66.9,28.9,69.7,26.1,73.2,26.1L73.2,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18017",
    className: "st0",
    d: "M89.4,34.3l-13.1-18c12-4.3,21.5-1.8,21.5-1.8S97.2,24.2,89.4,34.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18018",
    className: "st1",
    d: "M89.4,34.8L89.4,34.8c-0.2,0-0.3-0.1-0.4-0.2l-13.1-18c-0.2-0.2-0.1-0.6,0.1-0.7l0.1-0.1 c12-4.3,21.4-2,21.8-1.9c0.2,0.1,0.4,0.3,0.4,0.5c0,0.4-0.7,10.1-8.5,20.2C89.7,34.7,89.6,34.8,89.4,34.8 M77.1,16.5l12.3,16.9 c4.1-5.4,6.8-11.8,7.8-18.6C90.5,13.7,83.6,14.3,77.1,16.5L77.1,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18019",
    className: "st0",
    d: "M64,39L64,39c0.5,0.6,0.3,1.5-0.3,2L43.3,55.8c-0.6,0.5-1.5,0.4-2-0.2s-0.4-1.5,0.2-2 l0.1-0.1L62,38.7C62.7,38.2,63.5,38.4,64,39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18020",
    className: "st1",
    d: "M42.5,56.5c-1.1,0-1.9-0.8-1.9-1.9c0-0.6,0.3-1.2,0.8-1.6l20.4-14.8 c0.9-0.6,2.1-0.4,2.7,0.4c0.6,0.9,0.4,2.1-0.4,2.7l0,0L43.6,56.2C43.3,56.4,42.9,56.5,42.5,56.5 M41.8,55.1 c0.3,0.4,0.8,0.5,1.2,0.2l20.4-14.8c0.4-0.3,0.5-0.8,0.2-1.2C63.4,39.1,63.2,39,63,39s-0.5,0-0.7,0.2L42,53.9 c-0.2,0.1-0.3,0.3-0.3,0.6C41.6,54.7,41.6,54.9,41.8,55.1L41.8,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18021",
    className: "st1",
    d: "M75.4,36.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.2,0.1-0.4,0.3-0.5c0.7-0.3,1.3-0.9,1.7-1.6 c0.6-1.1,0.6-2.5,0-3.6c-0.1-0.3,0-0.6,0.2-0.7s0.6,0,0.7,0.2c0.8,1.5,0.8,3.2-0.1,4.7C77.2,35.5,76.4,36.2,75.4,36.6 C75.5,36.6,75.5,36.6,75.4,36.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18022",
    className: "st1",
    d: "M73.3,37.2c-0.1,0-0.2,0-0.4,0c-0.3,0-0.5-0.3-0.5-0.6s0.3-0.5,0.6-0.5 c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.6,0.1,0.6,0.4c0.1,0.3-0.1,0.6-0.4,0.6l0,0C74,37.1,73.7,37.2,73.3,37.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18023",
    className: "st1",
    d: "M15.1,62.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.2,0.1-0.4,0.3-0.5l0,0l27.3-14.7 c0.2-0.2,0.6-0.1,0.7,0.2s0.1,0.6-0.2,0.7l0,0L15.3,62.4C15.3,62.5,15.2,62.5,15.1,62.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18024",
    className: "st1",
    d: "M30.9,77.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0.1-0.3,0.2-0.4l19-19.5c0.2-0.2,0.5-0.2,0.7,0 s0.2,0.5,0,0.7L31.3,77C31.2,77.1,31,77.1,30.9,77.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18025",
    className: "st1",
    d: "M26.9,56.1c-0.2,0-0.4-0.1-0.5-0.4c-0.6-2.2-2.2-4-4.3-5c-2.8-1.3-6.8-1-10.7,0.6 c-0.3,0.1-0.6,0-0.7-0.3c0-0.1,0-0.2,0-0.3c0.1-2.2-1-4.2-2.9-5.3c-2-1-4.3-1.1-6.3-0.3c-0.3,0.1-0.6,0-0.7-0.3s0-0.6,0.3-0.7 l0,0c2.3-1,5-0.8,7.2,0.3c2,1.1,3.3,3.2,3.5,5.5c4-1.5,7.9-1.6,10.8-0.3c2.4,1.1,4.1,3.1,4.9,5.6c0.1,0.3-0.1,0.6-0.3,0.7 C27,56.1,27,56.1,26.9,56.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18026",
    className: "st1",
    d: "M17.1,65.2c-0.2,0-0.3-0.1-0.4-0.2c-4-5.7-12.2-5.2-12.3-5.2c-0.3,0-0.5-0.2-0.5-0.5 s0.2-0.5,0.5-0.5c0.4,0,8.9-0.5,13.2,5.6c0.2,0.2,0.1,0.6-0.1,0.7S17.2,65.2,17.1,65.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18027",
    className: "st3",
    d: "M5.3,74.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.2,0.1-0.4,0.3-0.5l0,0l28.7-16 c0.3-0.1,0.6-0.1,0.7,0.2c0.1,0.3,0.1,0.6-0.2,0.7l0,0l-28.7,16C5.5,74.3,5.4,74.3,5.3,74.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18028",
    className: "st3",
    d: "M4.3,83.2c-0.3,0-0.5-0.2-0.5-0.5c0-0.2,0.1-0.3,0.2-0.4L34.8,62c0.2-0.2,0.6-0.1,0.7,0.1 s0.1,0.6-0.1,0.7l0,0c0,0-0.1,0-0.1,0.1L4.6,83.1C4.5,83.2,4.4,83.2,4.3,83.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18029",
    className: "st3",
    d: "M21.3,82.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.2,0.1-0.3,0.2-0.4l5-4c0.2-0.2,0.6-0.1,0.7,0.1 l0,0l0,0c0.2,0.2,0.1,0.6-0.1,0.7l-4.9,4C21.5,82.5,21.4,82.6,21.3,82.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18030",
    className: "st3",
    d: "M30.9,70.4c-0.3,0-0.5-0.2-0.5-0.5c0-0.1,0.1-0.3,0.2-0.4l10.1-9.2c0.2-0.2,0.5-0.2,0.7,0 s0.2,0.5,0,0.7l0,0l0,0l-10.1,9.2C31.1,70.4,31,70.4,30.9,70.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18031",
    className: "st1",
    d: "M46.8,85.6L46.8,85.6c-0.4-0.1-0.6-0.3-0.5-0.6c0.4-2.7-1.4-5.3-4.1-5.8 c-0.3,0-0.5-0.3-0.4-0.6c0-0.1,0-0.1,0.1-0.2c1.9-3,0.9-7-2.1-8.9c-0.4-0.2-0.8-0.4-1.2-0.6c-0.3-0.1-0.4-0.4-0.3-0.7l0,0l0,0 c0.1-0.3,0.4-0.4,0.7-0.3c3.9,1.4,5.9,5.7,4.5,9.6c-0.1,0.3-0.2,0.5-0.3,0.8c1.3,0.4,2.4,1.2,3.2,2.3c1,1.3,1.4,2.9,1.1,4.5 C47.2,85.4,47,85.6,46.8,85.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18032",
    className: "st1",
    d: "M41.7,83.1L41.7,83.1c-0.4,0-0.6-0.3-0.5-0.6l0,0l0,0c0.3-2.5-1-4.8-3.2-6 c-0.3-0.1-0.4-0.4-0.3-0.7c0.1-0.3,0.4-0.4,0.7-0.3h0.1c2.6,1.4,4.1,4.2,3.8,7.1C42.2,82.9,42,83.1,41.7,83.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18033",
    className: "st3",
    d: "M12.4,57c-0.2,0-0.4-0.1-0.5-0.3c-0.3-0.7-0.7-1.4-1.2-2c-0.6-1-1.6-1.8-2.7-2.2 c-0.8-0.1-1.7-0.1-2.5,0.2c-0.3,0.1-0.6-0.1-0.6-0.4C4.8,52,5,51.7,5.3,51.7l0,0c1-0.2,2-0.3,3-0.1c1.4,0.4,2.6,1.3,3.4,2.6 c0.5,0.7,0.9,1.4,1.3,2.1c0.1,0.3,0,0.6-0.2,0.7l0,0l0,0C12.5,57,12.5,57,12.4,57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18034",
    className: "st3",
    d: "M91.1,76.8c-6.7,0-12.1-5.4-12.1-12.1s5.4-12.1,12.1-12.1l0,0c0.5,0,1,0,1.5,0.1 c1.8,0.2,3.5,0.8,5,1.8c5.1,3.2,7.1,9.8,4.5,15.3v0.1C100.1,74.1,95.8,76.8,91.1,76.8 M91.1,53.6c-6.1,0-11,5-11,11.1 c0,1.8,0.4,3.5,1.2,5.1c2.8,5.4,9.5,7.5,14.9,4.7c2.2-1.1,3.9-3,5-5.2v-0.1c0.7-1.4,1-3,1-4.5c0-3.8-1.9-7.3-5.2-9.4 c-1.4-0.9-2.9-1.4-4.6-1.6C92,53.6,91.6,53.6,91.1,53.6L91.1,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18035",
    className: "st3",
    d: "M91.1,76.8c-4.5,0-8.7-2.5-10.7-6.5c-0.1-0.2,0-0.5,0.2-0.7c0.6-0.4,1.1-0.9,1.6-1.5 c0.2-0.2,0.4-0.5,0.7-0.7c1-1.1,2.3-1.8,3.8-2c0.9,0,1.8,0.4,2.5,1.1c0.5,0.5,0.7,1.3,0.6,2c0,0.2-0.1,0.4-0.1,0.5 s-0.1,0.3-0.1,0.4c-0.1,0.8,0.7,1.5,1.5,1.8c0.5,0.1,1.1,0.2,1.6,0.3c0.5,0,1.1,0.1,1.6,0.3c1.4,0.4,2.6,1.3,3.3,2.5 c0.1,0.2,0.1,0.6-0.2,0.7C95.5,76.2,93.3,76.8,91.1,76.8 M81.5,70.2c3,5.2,9.5,7.1,14.8,4.3c-0.6-0.8-1.5-1.4-2.4-1.6 c-0.5-0.1-1-0.2-1.4-0.2c-0.6,0-1.2-0.2-1.8-0.3c-1.2-0.4-2.5-1.5-2.3-2.9c0-0.2,0.1-0.4,0.1-0.6c0-0.1,0.1-0.3,0.1-0.4 c0.1-0.4-0.1-0.8-0.3-1.1c-0.4-0.5-1-0.8-1.6-0.7c-1.2,0.1-2.3,0.7-3.1,1.7c-0.2,0.2-0.4,0.4-0.6,0.6 C82.5,69.3,82,69.8,81.5,70.2L81.5,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18036",
    className: "st3",
    d: "M101.7,70L101.7,70c-1-0.2-1.8-0.7-2.4-1.5c-0.4-0.6-0.6-1.2-0.8-1.8 c-0.4-1.1-0.6-1.8-1.3-2c-0.4-0.1-0.9,0-1.3,0.1C95.5,64.9,95,65,94.5,65c-0.7-0.1-1.4-0.5-1.8-1.1c-0.6-0.8-0.8-1.8-0.6-2.8 c0.4-1.5,1.3-2.8,2.5-3.8l0.3-0.2c0.8-0.7,1.5-1.5,2-2.4c0.1-0.3,0.5-0.3,0.7-0.2s0.3,0.5,0.2,0.7c-0.6,1-1.4,1.9-2.2,2.6 L95.3,58c-1,0.8-1.8,2-2.2,3.3c-0.1,0.7,0,1.4,0.5,2c0.3,0.4,0.6,0.6,1.1,0.7c0.4,0,0.7,0,1-0.1c0.6-0.2,1.2-0.2,1.8-0.1 c1.2,0.4,1.6,1.6,2,2.6c0.2,0.6,0.4,1.1,0.7,1.6c0.4,0.5,1,0.9,1.7,1c0.3,0,0.5,0.3,0.5,0.6C102.2,69.8,101.9,70.1,101.7,70 L101.7,70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18037",
    className: "st3",
    d: "M83.3,61.5c-1.1,0-2.1-0.3-3.1-0.8C80,60.6,79.9,60.3,80,60c1.9-4.5,6.3-7.5,11.2-7.4 c0.5,0,1,0,1.5,0.1c0.3,0,0.5,0.3,0.4,0.6v0.1C92.9,54,92.5,54.6,92,55c-0.7,0.6-1.6,1.2-2.5,1.6l-0.7,0.3 c-0.8,0.4-1.5,0.9-2,1.6c-0.2,0.3-0.3,0.6-0.4,0.9C86,60.7,84.7,61.6,83.3,61.5L83.3,61.5z M81.1,60c1.2,0.5,2.7,0.7,3.5,0.1 c0.3-0.3,0.6-0.7,0.7-1.2c0.1-0.4,0.3-0.8,0.6-1.1c0.7-0.8,1.5-1.4,2.4-1.9l0.7-0.4c0.8-0.4,1.5-0.8,2.2-1.4 c0.2-0.2,0.4-0.4,0.5-0.6h-0.6C86.9,53.6,83,56.1,81.1,60L81.1,60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18038",
    className: "st3",
    d: "M24.1,23.3c-3.6,0-6.6-2.9-6.6-6.6c0-3.6,2.9-6.6,6.6-6.6c3.6,0,6.6,2.9,6.6,6.6 S27.7,23.3,24.1,23.3L24.1,23.3 M24.1,11.2c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5l0,0 C29.6,13.7,27.2,11.2,24.1,11.2L24.1,11.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18039",
    className: "st3",
    d: "M16.6,24.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.5-0.4-0.5-0.7c-0.1-1,1.8-2.8,2.9-3.7 c0.2-0.2,0.6-0.2,0.7,0.1c0.2,0.2,0.2,0.6-0.1,0.7l0,0c-0.9,0.7-1.8,1.6-2.5,2.6c2.5-0.8,14.1-9.5,15.3-11.4 c-1.3,0.1-2.5,0.5-3.7,1.1c-0.2,0.1-0.6,0.1-0.7-0.2c-0.1-0.2-0.1-0.6,0.2-0.7c0,0,0,0,0.1,0c0.5-0.3,3.3-1.6,4.6-1.2 c0.3,0.1,0.5,0.3,0.6,0.6c0.2,0.4-0.1,0.9-1,1.9C30,15.6,18.9,24.2,16.6,24.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18040",
    className: "st3",
    d: "M77.9,6.6c-0.9,0-1.6,0.7-1.5,1.6c0,0.8,0.7,1.5,1.5,1.5c0.9,0,1.6-0.7,1.5-1.6 C79.5,7.3,78.8,6.6,77.9,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18041",
    className: "st3",
    d: "M12.2,7.1c-0.9,0-1.6,0.7-1.5,1.6c0,0.8,0.7,1.5,1.5,1.5c0.9,0,1.6-0.7,1.5-1.6 C13.7,7.8,13.1,7.1,12.2,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18042",
    className: "st3",
    d: "M101.7,36.9c-0.9,0-1.6,0.7-1.5,1.6c0,0.8,0.7,1.5,1.5,1.5c0.9,0,1.6-0.7,1.5-1.6 C103.2,37.6,102.5,36.9,101.7,36.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18043",
    className: "st3",
    d: "M43.5,13.1c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7l0,0 C45.2,12.4,44.4,13.1,43.5,13.1 M43.5,10.8c0,0.4,0.3,0.6,0.6,0.6c0.4,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6S43.5,10.5,43.5,10.8 L43.5,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18044",
    className: "st3",
    d: "M49.8,77.9c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7l0,0 C51.5,77.2,50.8,77.9,49.8,77.9 M49.8,75.6c-0.4,0-0.6,0.3-0.6,0.6c0,0.4,0.3,0.6,0.6,0.6c0.4,0,0.6-0.3,0.6-0.6l0,0 C50.5,75.9,50.2,75.6,49.8,75.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18045",
    className: "st3",
    d: "M71,72.7c-0.3,0-0.5-0.2-0.5-0.5l0,0v-1.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.6 C71.5,72.5,71.3,72.7,71,72.7L71,72.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18046",
    className: "st3",
    d: "M71,76.8c-0.3,0-0.5-0.2-0.5-0.5l0,0v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7 C71.5,76.6,71.3,76.8,71,76.8L71,76.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18047",
    className: "st3",
    d: "M73.8,73.9h-1.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.7c0.3,0,0.5,0.2,0.5,0.5 S74.1,73.9,73.8,73.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18048",
    className: "st3",
    d: "M69.8,73.9h-1.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.7c0.3,0,0.5,0.2,0.5,0.5 S70.1,73.9,69.8,73.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18049",
    className: "st3",
    d: "M59.8,13c-0.3,0-0.5-0.2-0.5-0.5l0,0v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7 C60.4,12.8,60.1,13,59.8,13L59.8,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18050",
    className: "st3",
    d: "M59.8,17.1c-0.3,0-0.5-0.2-0.5-0.5l0,0v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7 C60.4,16.9,60.1,17.1,59.8,17.1L59.8,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18051",
    className: "st3",
    d: "M62.7,14.2H61c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5l0,0h1.7c0.3,0,0.5,0.2,0.5,0.5 S63,14.2,62.7,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18052",
    className: "st3",
    d: "M58.6,14.2H57c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.7c0.3,0,0.5,0.2,0.5,0.5 C59.1,14,58.9,14.2,58.6,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18053",
    className: "st3",
    d: "M22.5,35.9c-0.3,0-0.5-0.2-0.5-0.5l0,0v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7 C23,35.7,22.7,35.9,22.5,35.9L22.5,35.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18054",
    className: "st3",
    d: "M22.5,40c-0.3,0-0.5-0.2-0.5-0.5l0,0v-1.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.7 C23,39.8,22.7,40,22.5,40L22.5,40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18055",
    className: "st3",
    d: "M25.3,37.2h-1.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5l0,0h1.7c0.3,0,0.5,0.2,0.5,0.5 C25.8,36.9,25.6,37.2,25.3,37.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18056",
    className: "st3",
    d: "M21.2,37.2h-1.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.7c0.3,0,0.5,0.2,0.5,0.5 C21.8,36.9,21.5,37.2,21.2,37.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18057",
    className: "st3",
    d: "M97.1,48.4c-0.3,0-0.5-0.2-0.5-0.5l0,0v-4.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.2 C97.6,48.2,97.4,48.4,97.1,48.4L97.1,48.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18058",
    className: "st3",
    d: "M99.2,46.4H95c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5l0,0h4.2c0.3,0,0.5,0.2,0.5,0.5 C99.7,46.1,99.4,46.4,99.2,46.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18059",
    className: "st3",
    d: "M8.9,30.7c-0.3,0-0.5-0.2-0.5-0.5V26c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.2 C9.4,30.5,9.2,30.7,8.9,30.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18060",
    className: "st3",
    d: "M11,28.7H6.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5l0,0H11c0.3,0,0.5,0.2,0.5,0.5 C11.5,28.4,11.2,28.7,11,28.7"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickStartNew);
export default __webpack_public_path__ + "static/media/quick_start_new.8b7f846e9d5bc07d8b962d85dfd5b6f5.svg";
export { ForwardRef as ReactComponent };